import { render, staticRenderFns } from "./UploadArquivosAfericao.vue?vue&type=template&id=3add3c14&"
import script from "./UploadArquivosAfericao.vue?vue&type=script&lang=js&"
export * from "./UploadArquivosAfericao.vue?vue&type=script&lang=js&"
import style0 from "./UploadArquivosAfericao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports